import store from '@/store';

const DimensionViewer = {
  name:   'dimensionViewer',
  props:  {},
  events: {},
  css:    ['otherTarget'],
  render(moveable, React) {
    const rect       = moveable.getRect();
    const translateX =  (moveable.props.cropHandle) ? 124 : 82;
    const { pos2 }   = moveable.state;
    let scaleX       = 1;
    let scaleY       = 1;
    let diff         = 0;
    if (moveable.props.target) {
      const matrix = new DOMMatrixReadOnly(moveable.props.target.style.transform);
      scaleX       = matrix.a;
      scaleY       = matrix.d;
      try {
        if (moveable.props.target.dataset.type && moveable.props.target.dataset.type == 'text') { diff = 10; }
      } catch (ex) {
        console.log(ex.message);
      }
    }

    const width         = store.getters.getIsUnitInInch ? `${((rect.offsetWidth - diff) * scaleX / 72).toFixed(2)}in` : `${Math.round((rect.offsetWidth - diff) * scaleX)}px`;
    const height        = store.getters.getIsUnitInInch ? `${(rect.offsetHeight * scaleY / 72).toFixed(2)}in` : `${Math.round(rect.offsetHeight * scaleY)}px`;
    const contentWidth  = `W: ${width}`;
    const contentheight = `H: ${height}`;

    return React.createElement('div', {
      class: 'dimension-viewer',
      style: {
        position:        'absolute',
        left:            '0px',
        top:             '0px',
        transform:       `translate(${pos2[0]}px, ${pos2[1]}px) rotate(${rect.rotation}deg) translate(10px, ${translateX}px)`,
        transformOrigin: '0 0',
      },
      key: 'dimension-viewer',
    }, React.createElement('p', null, contentWidth),
    React.createElement('p', null, contentheight));
  },
};
export default DimensionViewer;
